export const blockIconsHouseholdModeHeatNew = (
	<span className='material-symbols-outlined'>mode_heat</span>
);
